import { render, staticRenderFns } from "./ModalPrivateShare.vue?vue&type=template&id=88c4fa5c"
import script from "./ModalPrivateShare.vue?vue&type=script&lang=js"
export * from "./ModalPrivateShare.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivateShare.vue?vue&type=style&index=0&id=88c4fa5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports